/*
 * CART MANAGER
 */

/* notifications */

/* END notifications */

/**
 * aggiunge un indirizzo
 */
function order_addNewAddress() {

    $.get( url__edit_address, {
        time: Date.now()
    } , function( data ) {

        $("#shipping-address-form-wrapper").html(data);

        $('#shipping_address_province').selectpicker('refresh');
        $('#shipping_address_nation').selectpicker('refresh');

    }).fail(function () {
        //location.reload();
    });
}

/**
 * mostra un indirizzo
 */
function order_showAddress(id, t) {

    $.get( url__edit_address, {
        id: id,
        readonly: true,
        t: t,
        time: Date.now()
    } , function( data ) {

        $("#shipping-address-form-wrapper").html(data);
        if (id) {
            initCheckHideProvinceBox();
        }

    }).fail(function () {
        //location.reload();
    });
}

/* notifications */

function notifyShippingCosts(element, style, title, content) {

    // $(element).notify({
    //     title: title,
    //     content: content,
    //     footer: '<button type="button" class="button-default button-orange font-17 c-white">' +
    //     '<span>'            +
    //     'OK'            +
    //     '</span>'           +
    //     '</button>'
    // }, {
    //     arrowShow: false,
    //     style: 'rgb-notification-shipping-costs',
    //     className: style,
    //     autoHide: false,
    //     position: 'top',
    //     showAnimation: 'slideDown',
    //     showDuration: 400,
    //     hideAnimation: 'slideUp',
    //     hideDuration: 200
    // });
}